export type TokenTypes = 'br' | 'phone' | 'bold' | 'italic'| 'linetrough' | 'email'| 'site' | 'text'

interface TokenType {
    name: TokenTypes
    pattern: RegExp
}

export interface Token {
    name: TokenTypes
    input: string
}

var tokenTypes:TokenType[] = [
    {name: 'br', pattern: /\r?\n/yg},
    {name: 'phone', pattern: /[\(\d][\)\.\d -]{5,}[\)\.\d]/yg},
    {name: 'bold', pattern: /\*(.+?)\*/yg},
    {name: 'italic', pattern: /_(.+?)_/yg},
    {name: 'linetrough', pattern: /~(.+?)~/yg},
    {name: 'email', pattern: /[a-z0-9\.-]+@[a-z0-9\.-]+/yg},
    {name: 'site', pattern: /https?:\/\/[^\r\n ,\)]+/yg},
    {name: 'text', pattern: /(.+?)(?=(\*|_|~|https?:|[\(\)\d -]{6,}|[a-z0-9\.-]+@[a-z0-9\.-]+|[\r\n]|$))/myg}
]

export function tokenizer(str: string):Token[]{
    var tokens:Token[] = []
    var lastIndex = 0;
    while(true){
        if (lastIndex == str.length) break;
        let matched = false;
        for(let t of tokenTypes){
            t.pattern.lastIndex = lastIndex;
            let match = t.pattern.exec(str);
            if(!match) 
                continue;
            
            let input = match[0];
            lastIndex += input.length;  
            matched = true;
            tokens.push({name: t.name, input});
            break;
        }
        if(!matched) break;
    }

    return tokens;
}